import DashbardData from "pages/apps/dashboardMaster/dashboard_data/dashboardData";
import React from "react";

const Page1 = React.lazy(() => import("./Page1"));
const Page2 = React.lazy(() => import("./Page2"));
export const samplePagesConfigs = [
  {
    path: "/dashboard",
    element: <DashbardData/>,
  },
  {
    path: "/sample/page-2",
    element: <Page2 />,
  },
];
